export default {"src":"/_next/static/media/stomach.c2ce5472.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};